import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
// import counterReducer from "../features/counter/counterSlice";
import reducerFilter from "../blocks/Filter/FilterSlice";
import reducerApp from "../blocks/App/AppSlice";

export const store = configureStore({
  reducer: {
    filter: reducerFilter,
    app: reducerApp
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
